module.exports = __webpack_public_path__ + "media/site_templates/www.localcleaners.net.au/images/splash-e0c703e2dbf895360aefe42b9130df6d.jpeg";